// noinspection JSUnusedGlobalSymbols

import { JwtHelperService } from '@auth0/angular-jwt';

export class AuthenticatedUser
{
    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Map Pascal Cased property names to camel case property names to support compatibility with existing code.
            this.token = json['Token'];
            this.expiration = json['Expiration'];
            this.refreshToken = json['RefreshToken'];
            this.refreshTokenExpiration = json['RefreshTokenExpiration'];
        }

        // Handle any custom mappings here or use getters and setters. Object.assign will call
        // property setters.
    }

    public token: string | undefined = undefined;
    public refreshToken: string | undefined = undefined;

    private _expiration!: Date;
    public get expiration(): Date
    {
        return this._expiration;
    }

    public set expiration(value: Date)
    {
        this._expiration = new Date(value);
    }

    private _refreshTokenExpiration!: Date;
    public get refreshTokenExpiration(): Date
    {
        return this._refreshTokenExpiration!;
    }

    public set refreshTokenExpiration(value: Date)
    {
        this._refreshTokenExpiration = new Date(value);
    }

    private _sid!: string;
    public get sid(): string
    {
        if (!this._sid)
        {
            this._sid = this.parseTokenValue('sid')!;
        }
        return this._sid;
    }

    private _sub!: string;
    public get sub(): string
    {
        if (!this._sub)
        {
            this._sub = this.parseTokenValue('sub')!;
        }
        return this._sub;
    }

    private _firstName!: string;
    public get firstName(): string
    {
        if (!this._firstName)
        {
            this._firstName = this.parseTokenValue('given_name')!;
        }
        return this._firstName;
    }

    private _lastName!: string;
    public get lastName(): string
    {
        if (!this._lastName)
        {
            this._lastName = this.parseTokenValue('family_name')!;
        }
        return this._lastName;
    }

    public get fullName(): string
    {
        return `${this.firstName} ${this.lastName}`;
    }

    private _uniqueName: string | undefined = undefined;
    public get uniqueName(): string | undefined
    {
        if (!this._uniqueName)
        {
            this._uniqueName = this.parseTokenValue('unique_name');
        }
        return this._uniqueName;
    }

    private _email: string | undefined = undefined;
    public get email(): string
    {
        if (!this._email)
        {
            this._email = this.parseTokenValue('email')!;
        }
        return this._email;
    }

    private _tenantId: string | undefined = undefined;
    public get tenantId(): string
    {
        if (!this._tenantId)
        {
            this._tenantId = this.parseTokenValue('TenantId')!;
        }
        return this._tenantId;
    }

    private _isGlobalAdmin: boolean | undefined = undefined;
    public get isGlobalAdmin(): boolean
    {
        if (!this._isGlobalAdmin)
        {
            this._isGlobalAdmin = this.parseTokenValue('IsGlobalAdmin')?.toLowerCase() === 'true';
        }
        return this._isGlobalAdmin;
    }

    private _isOrgAdmin: boolean | undefined = undefined;
    public get isOrgAdmin(): boolean
    {
        if (!this._isOrgAdmin)
        {
            this._isOrgAdmin = this.parseTokenValue('IsOrgAdmin')?.toLowerCase() === 'true';
        }
        return this._isOrgAdmin;
    }

    private _hasMultipleOrgs: boolean | undefined = undefined;
    public get hasMultipleOrgs(): boolean
    {
        if (!this._hasMultipleOrgs)
        {
            this._hasMultipleOrgs = this.parseTokenValue('HasMultipleOrgs')?.toLowerCase() === 'true';
        }
        return this._hasMultipleOrgs;
    }

    private _isMember: boolean | undefined = undefined;
    public get isMember(): boolean
    {
        if (!this._isMember)
        {
            this._isMember = this.parseTokenValue('IsMember')?.toLowerCase() === 'true';
        }
        return this._isMember;
    }

    private _organizationId: string | undefined = undefined;
    public get organizationId(): string | undefined
    {
        if (!this._organizationId)
        {
            this._organizationId = this.parseTokenValue('OrganizationId');
        }
        return this._organizationId;
    }

    private _accessInfo: string | undefined = undefined;
    public get accessInfo(): any | undefined
    {
        if (!this._accessInfo)
        {
            this._accessInfo = this.parseTokenValue('AccessInfo');
            this._accessInfo = this._accessInfo == undefined || this._accessInfo.length === 0 ? undefined : JSON.parse(this._accessInfo);
        }
        return this._accessInfo;
    }

    // GlobalAdmin, OrgAdmin, Member
    private _roles: string | undefined = undefined;
    public get roles(): string | undefined
    {
        if (!this._roles)
        {
            this._roles = this.parseTokenValue('roles');
        }
        return this._roles;
    }

    // private _claims;
    // public get claims(): UserClaims
    // {
    //     if (!this._claims)
    //     {
    //         this._claims = new UserClaims(this.decodedToken);
    //     }
    //     return this._claims;
    // }

    public isLoggedIn()
    {
        return this.token && this.token.length > 0 && this.refreshTokenExpiration >= new Date();
    }

    // ======================================================================================================
    // Helper Methods
    // ======================================================================================================
    private get decodedToken(): any
    {
        return this.token ? new JwtHelperService().decodeToken(this.token) : null;
    }

    private parseTokenValue(value: string): string | undefined
    {
        return (this.decodedToken && this.decodedToken[value]) ? this.decodedToken[value] : undefined;
    }

}
